import {Component, ChangeDetectionStrategy} from "@angular/core"
import {BaseInspectorComponent} from "@app/template-editor/components/inspectors/base-inspector/base-inspector.component"
import {InspectorSectionComponent} from "@app/template-editor/components/inspectors/inspector-section/inspector-section.component"
import {ValueSlotComponent} from "@app/template-editor/components/value-slot/value-slot.component"
import {DistanceTexture} from "@cm/template-nodes"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-distance-texture-inspector",
    templateUrl: "./distance-texture-inspector.component.html",
    styleUrl: "./distance-texture-inspector.component.scss",
    imports: [InspectorSectionComponent, ValueSlotComponent],
})
export class DistanceTextureInspectorComponent extends BaseInspectorComponent<DistanceTexture> {}
